<template>
  <div class="field">
    <p class="control has-icons-right">
      <input
        v-model="content"
        type="text"
        class="input search-input"
        :class="{ 'is-small': isSmall }"
        placeholder="Search"
      />
      <span class="icon is-small is-right icon-search"> </span>
    </p>
  </div>
</template>
<script>
// import _ from 'lodash';

export default {
  name: 'Search',
  props: {
    value: {
      type: String,
      default: null
    },
    isSmall: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      content: ''
    };
  },
  watch: {
    value() {
      if (this.value != this.content) {
        this.content = this.value;
      }
    },
    content() {
      if (this.value != this.content) {
        this.$emit('input', this.content);
      }
    }
  }
};
</script>

<style lang="scss">
.search-input {
  border: none;
  border-bottom: 1px solid rgba($white, 0.15);
  border-radius: 0;
  box-shadow: none !important;
  padding-left: 4px;

  &:focus {
    border-bottom: solid 1px $primary;
  }
}
</style>
